import { BaseModalV2 } from 'components/ui/BaseModal'
import React, { useRef, useState } from 'react'
import useLocaleText from 'components/useLocaleText'
import { ModalHeader } from '../commonUI/Modal/ModalHeader'
import { ModalFooter } from '../commonUI/Modal/ModalFooter'
import { FormRef } from 'redux/actions/campaigns'
import { IPresetPrompt } from './PromptsTable'
import { PromptForm } from './Form'

interface PromtsModalProps {
  isOpen: boolean
  onClose: () => void
  onRequestClose: () => void
  prompt?: (IPresetPrompt & { prompt: string }) | null
}

const PromtsModal = ({ isOpen, onClose, onRequestClose, prompt }: PromtsModalProps) => {
  const create_title = useLocaleText('prompt_create', true)
  const edit_prompt = useLocaleText('edit_prompt', true)
  const modal_title = prompt ? edit_prompt : create_title
  const admin_submit_button = useLocaleText('admin_submit_button')
  const [isPromtreating, setIsPromtreating] = useState(false)

  const formRef = useRef<FormRef>(null)

  const handleSubmitClick = async () => {
    setIsPromtreating(true)
    try {
      await formRef.current?.submit()
    } catch (error) {
      console.error('Submit error:', error)
    } finally {
      setIsPromtreating(false)
    }
  }

  return (
    <BaseModalV2
      isOpen={isOpen}
      onClose={onClose}
      header={<ModalHeader title={modal_title} onClose={onRequestClose} />}
      body={<PromptForm ref={formRef} onClose={onClose} prompt={prompt} />}
      footer={<ModalFooter isLoading={isPromtreating} onSubmit={handleSubmitClick} buttonText={admin_submit_button} />}
      modalContentProps={{
        w: '100%',
        maxW: { base: '90vw', md: '80vw', lg: '800px' },
        minW: '350px',
      }}
      modalBodyProps={{
        height: 'auto',
        minH: '50vh',
        maxH: { base: '80dvh', md: '70dvh' },
        opacity: isPromtreating ? 0.5 : 1,
        pointerEvents: isPromtreating ? 'none' : 'auto',
      }}
      modalHeaderProps={{
        boxShadow: 'none',
        opacity: isPromtreating ? 0.5 : 1,
        pointerEvents: isPromtreating ? 'none' : 'auto',
      }}
    />
  )
}

export default PromtsModal
